<template>
  <div id="fun-part-journey" class="mx-auto max-w-screen-xl">
    <MoleculesLoadingOverlay v-if="loading" />
    <Organisms v-else :organisms="organisms" />
    <OrganismsModalForm>
      <header class="mb-4">
        <h2 class="mb-4 text-4xl font-semibold text-black font-archer">
          Be the First
        </h2>
        <p v-if="!isFormSubmitted" class="text-lg text-gray-500">
          Please provide us your information and we will get back to you.
        </p>
      </header>
      <FormsHubSpotForm
        :form="{ id: '767c334f-0893-4757-8fa6-fd4b253bd691' }"
        @submit="isFormSubmitted = true"
      />
    </OrganismsModalForm>
  </div>
</template>

<style>
#fun-part-journey {
  .brand-window-text-overlay {
    @apply min-h-min md:min-h-[500px] h-80 md:h-[500px];
  }

  .split-content .text-gallery,
  .split-content .gallery-text {
    @apply max-w-7xl;
  }

  #fun-part-logo img {
    @apply mx-auto max-w-[min(280px,_100%)];
  }

  .organism.timeline {
    @apply !mb-0;
  }

  #organism-3.wysiwyg-block {
    @apply px-8;

    h2 {
      @apply text-3xl font-semibold md:text-5xl font-archer max-w-3xl mx-auto mb-8;
    }

    p {
      @apply max-w-3xl mx-auto mb-4 text-justify text-gray-500 text-lg leading-8;
    }
  }

  .heading-transition {
    @apply mb-0;
  }

  .split-content {
    @apply mb-0;

    .content {
      @apply grid grid-cols-1 gap-4 md:grid-cols-1 md:gap-4 lg:grid-cols-2 lg:gap-8;
    }

    .text-gallery {
      .swiper-container {
        @apply -order-1 md:-order-1 lg:order-2;
      }
    }

    .text {
      @apply flex flex-col;

      h2.title-1 {
        @apply text-black font-bold;
      }

      h4.title-3 {
        @apply uppercase text-[17px] text-bc-blue font-bold mb-2 -order-1;
      }
    }
    .description {
      @apply mb-0;

      p {
        @apply leading-6 mb-4;
      }
      table {
        @apply table-fixed w-full;

        tr {
          @apply flex flex-wrap;
          td {
            @apply align-top md:w-1/2 min-w-[200px];
          }
        }
      }
      ul {
        @apply list-disc;

        li {
          @apply leading-6 mb-2;
        }
      }
    }
  }

  .site-map-cta {
    & > img {
      @apply mix-blend-overlay;
    }
  }

  #three-column-contact.flexible-content-columns {
    @apply mb-20;

    & > div {
      @apply border-2 border-gray-300 flex flex-col items-center justify-center p-10 gap-8 bg-white;
    }

    img {
      @apply w-20;
    }

    h3 {
      @apply font-archer font-semibold text-[28px] text-gray-700 leading-none;
    }

    .description {
      @apply text-lg text-gray-700 text-center;

      a {
        @apply underline text-bc-blue;
      }
    }
  }
}
</style>

<script setup>
import { useAsyncQuery } from "#imports";
import { GET_ORGANISMS } from "~/graphql/GetOrganisms";
import { storeToRefs } from "pinia";
const breadcrumbs = useBreadcrumbs();
const { breadcrumbsList } = storeToRefs(breadcrumbs);
const modalForm = useModalForm();
const isFormSubmitted = ref(false);

breadcrumbsList.value = [];

const { data, pending, error } = await useAsyncQuery(GET_ORGANISMS, {
  uri: "/about-us/fun-part-journey/",
});

const organisms = computed(() => {
  return data.value?.organisms?.hlOrganisms?.hlOrganism ?? [];
});

const loading = pending;

onMounted(() => {
  window.addEventListener(
    "hashchange",
    () => {
      if (window.location.hash === "#modal-form") {
        modalForm.openModal();
        window.location.hash = "";
      }
    },
    false,
  );

  addTriggers();
});

const addTriggers = () => {
  const modalFormTriggers = document.querySelectorAll("a[href$='#modal-form']");

  modalFormTriggers.forEach((node) => {
    // Clone & replace node to remove existing event listeners
    const clonedNode = node.cloneNode(true);
    node.parentNode.replaceChild(clonedNode, node);

    clonedNode.addEventListener("click", (event) => {
      // Add event listener
      event.preventDefault();
      modalForm.openModal();
    });
  });
};

onUpdated(() => {
  addTriggers();
});
</script>
